import isEmpty from "lodash/isEmpty";
import { RequirementType } from "PFTypes";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BookingFormCommonInputs } from "./booking_form_common_inputs";
import { BookingFormValues } from "./booking_form_values.types";
import { BookingType } from "./booking_type";

type BookingFormGlobalInputsProps = {
  canSelectEngagement: boolean;
};

export const BookingFormGlobalInputs = ({ canSelectEngagement }: BookingFormGlobalInputsProps) => {
  const { t } = useTranslation("bookingModule");
  const [bookings, bookingType, activityId] = useWatch<
    BookingFormValues,
    ["bookings", "bookingType", "activityId"]
  >({
    name: ["bookings", "bookingType", "activityId"]
  });

  const isOverridesNonWorkingDaysGlobalDisabled =
    isEmpty(bookings) ||
    bookings.some((item) => item.requirement?.type === RequirementType.Load) ||
    bookingType === BookingType.Repeated;

  const getCategoryTip = ({ options }) =>
    isEmpty(options) && canSelectEngagement && !activityId
      ? t("bookings.create.categoryTipNoNonDemandCategories")
      : undefined;

  return (
    <BookingFormCommonInputs
      overridesDiaryTimeFormValueName="globalOverridesDiaryTime"
      overridesNonWorkingTimeFormValueName="globalOverridesNonWorkingTime"
      categoryFormValueName="globalCategory"
      categoryFormErrorKeys={[
        "globalCategory",
        "globalCategoryErrorAPI.submit",
        "globalCategoryErrorAPI.potential-warnings"
      ]}
      titleFormValueName="globalTitle"
      descriptionFormValueName="globalDescription"
      isOverridesNonWorkingDaysDisabled={isOverridesNonWorkingDaysGlobalDisabled}
      getCategoryTip={getCategoryTip}
    />
  );
};
